import React, { useState, useEffect, Fragment } from "react";
import { useConfig } from "@eis-poc/lib-discover-medical-mfes";
import CallToActionModal from "./CallToActionModal";
import { EVENT_BUS_EVENTS } from "../../utils/useEventBus";

const CTA_TYPE_GENERIC = "generic";

const CallToActionWrapper = ({ eventBus }) => {
  const [ctaToUse, setCtaToUse] = useState(null);
  const [shouldShowCtaModal, setCtaModalIsOpen] = useState(false);

  const { ctas } = useConfig();

  const setCta = (type = CTA_TYPE_GENERIC, originator = {}) => {
    const {
      mfe = "unknown",
      component: mfeComponent = "unknown",
      userAction = "unknown"
    } = originator;
    const theCta = ctas?.[type];
    if (theCta) {
      setCtaToUse(theCta);
    } else {
      if (window?.DD_RUM) {
        window.DD_RUM.addError(
          `CallToAction: failed to find matching CTA from config with "${type}". CTA triggered from ${mfeComponent} inside ${mfe} MFE by ${userAction} user action`,
          {
            scope: "mfe-container",
            team: "cd.ghostriders",
            component: "CallToActionWrapper"
          }
        );
      }
    }
  };

  useEffect(() => {
    const handler = (context) => {
      setCta(context?.type, context?.originator);
      setCtaModalIsOpen(true);
    };
    eventBus.on(EVENT_BUS_EVENTS.LAUNCH_CTA, handler);
    return () => eventBus.detach(EVENT_BUS_EVENTS.LAUNCH_CTA, handler);
  }, [eventBus]);

  return (
    <Fragment>
      <CallToActionModal
        isOpen={shouldShowCtaModal}
        onRequestClose={() => {
          setCtaModalIsOpen(false);
          setCtaToUse(null);
        }}
        cta={ctaToUse}
      />
    </Fragment>
  );
};

CallToActionWrapper.displayName = "CallToActionWrapper";
export default CallToActionWrapper;
